import { useState } from 'react';


export default function FAQ() {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleFAQ = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "What is WizardPortrait?",
      answer: "WizardPortrait is a magical service that provides you an APP to transform your television or digital display into an enchanted living portrait completely personalized to you. The portrait speaks, responds, and lives alongside you, inspired by the magical world of wizards."
    },
    {
      question: "How does it work?",
      answer: "Our technology combines AI with advanced animation to create a responsive portrait that interacts with you. Simply install our app on your smart TV or any digital display, and your portrait will come to life."
    },
    {
      question: "Can I choose my portrait character?",
      answer: "Yes! Your imagination is the limit! From classic wizard portraits to modern magical interpretations of yourself or even your pets."
    },
    {
      question: "Is an internet connection required?",
      answer: "Yes, WizardPortrait requires an internet connection to enable the interactive features and AI responses. However, basic portrait animations can work offline."
    },
    {
      question: "What displays are compatible?",
      answer: "WizardPortrait works with any smart TV that supports our app, or any digital display that can connect to our WizardPortrait app. This includes most modern TVs, monitors, cellphones, tablets, and digital frames."
    },
    {
      question: "Do you offer refunds?",
      answer: "We offer a 30-day satisfaction guarantee. If you're not completely enchanted with your portrait, contact our support wizards for assistance or to process a refund."
    },
    {
      question: "What can I do with the portrait?",
      answer: "You can use the portrait to ask general questions or online available information, ask for news summaries, or even play games. Imagine it is a much cooler version of ChatGPT that lives on your TV, has a personality, remembers what you like and learns from your preferences. The possibilities are endless!"
    },
    {
      question: "Does it have its own life?",
      answer: "Yes, it has a life of its own, just like the magical portraits in our favorite castle. While you are not interacting with it, watch as it interacts with it's own frame environment with new content being generated everyday."
    }
  ];

  return (
    <section className="faq">
      <div className="faq-content">
        <h2 className="faq-title">
          <span className="faq-title-accent"></span> FAQ
        </h2>
        <p className="faq-subtitle">
          Curious about our magical portraits? Find answers to common questions below.
        </p>

        <div className="faq-questions">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className="faq-item"
            >
              <button 
                onClick={() => toggleFAQ(index)}
                className="faq-question"
              >
                <h3>{faq.question}</h3>
                <span className={expandedIndex === index ? 'faq-icon open' : 'faq-icon'}>
                  +
                </span>
              </button>
              <div 
                className={expandedIndex === index ? 'faq-answer open' : 'faq-answer'}
              >
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>

   
      </div>

      <style jsx>{`
        .faq {
          padding: 8rem 2rem;
          text-align: center;
          position: relative;
          background: radial-gradient(circle at 50% 50%, rgba(11, 8, 17, 0.2) 0%, rgba(7, 5, 9, 0.12) 70%);
          overflow: visible;
          width: 100%;
          cursor: default;
        }
        
        .faq::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(135deg, rgba(0, 0, 0, 0.95) 0%, rgba(32, 26, 46, 0.95) 100%);
          z-index: 0;
        }
        
        .faq-content {
          max-width: 800px;
          margin: 0 auto;
          position: relative;
          z-index: 2;
        }
        
        .faq-title {
          font-size: 3rem;
          margin-bottom: 1.5rem;
          color: #ffffff;
          font-family: serif;
          font-weight: 400;
        }
        
        .faq-title-accent {
          color: #f9b932;
        }
        
        .faq-subtitle {
          font-size: 1.2rem;
          margin-bottom: 2.5rem;
          color: #ffffff;
          opacity: 0.9;
        }
        
        .faq-questions {
          display: flex;
          flex-direction: column;
          gap: 1rem;
          margin-bottom: 2.5rem;
        }
        
        .faq-item {
          background: rgba(36, 36, 60, 0.7);
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
          border: 1px solid rgba(255, 255, 255, 0.05);
          transition: all 0.5s cubic-bezier(0.25, 0.1, 0.25, 1);
          text-align: left;
        }
        
        .faq-item:hover {
          box-shadow: 0 8px 25px rgba(249, 185, 50, 0.1);
          transform: translateY(-3px);
        }
        
        .faq-question {
          width: 100%;
          text-align: left;
          padding: 1.5rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: none;
          border: none;
          cursor: pointer;
          color: white;
        }
        
        .faq-question h3 {
          font-size: 1.1rem;
          font-weight: 500;
          margin: 0;
        }
        
        .faq-icon {
          color: #f9b932;
          font-size: 1.5rem;
          transition: transform 0.3s ease;
          display: inline-block;
        }
        
        .faq-icon.open {
          transform: rotate(45deg);
        }
        
        .faq-answer {
          padding: 0 1.5rem;
          max-height: 0;
          overflow: hidden;
          opacity: 0;
          transition: all 0.5s cubic-bezier(0.25, 0.1, 0.25, 1);
        }
        
        .faq-answer.open {
          padding: 0 1.5rem 1.5rem 1.5rem;
          max-height: 500px;
          opacity: 1;
        }
        
        .faq-answer p {
          color: rgba(255, 255, 255, 0.8);
          line-height: 1.6;
        }
        
        .faq-cta {
          margin-top: 3rem;
          text-align: center;
        }
        
        .faq-cta p {
          color: #ffffff;
          opacity: 0.9;
          margin-bottom: 1.5rem;
        }
        
        @media (max-width: 768px) {
          .faq-title {
            font-size: 2.5rem;
          }
        }
      `}</style>
    </section>
  );
} 